package fr.labodoc.healthProfessional.api.payloads.responses

import kotlinx.serialization.Serializable

@Serializable
data class MedicalDiplomasResponse(
  val medicalDiplomas: List<MedicalDiploma>
) {
  @Serializable
  data class MedicalDiploma(
    val id: String,
    val name: String,
    val healthDirectoryProfessionCode: String,
    val labodocMedicalSpeciality: MedicalSpeciality
  ) {
    @Serializable
    data class MedicalSpeciality(
      val id: String,
      val medicalProfession: MedicalProfession,
      val name: String,
      val medicalInterests: List<MedicalInterest>
    ) {
      @Serializable
      data class MedicalProfession(
        val id: String,
        val name: String
      )

      @Serializable
      data class MedicalInterest(
        val id: String,
        val name: String
      )
    }
  }
}
